import { PlpContext } from "@/providers/plp-provider";
import {
  useContext,
  useMemo,
  useRef,
  useEffect,
  useState,
  useCallback,
} from "preact/hooks";
import Facet from "@/components/facet";
import { Fragment } from "preact";
import AOS from "aos";

export default function PlpSidebar() {
  const { facets, pickedFacets, setUrl, urlManager, products, url } =
    useContext(PlpContext);

  const subCollections =
    window.GLOBAL && window.GLOBAL.subColections
      ? window.GLOBAL.subColections
      : "";

  const refinerFilters = useMemo(
    () => urlManager.searchParams.get("refinerFilters")?.split("||"),
    [url]
  );

  const range = useMemo(
    () => urlManager.searchParams.get("range")?.split("||"),
    [url]
  );

  const price = useMemo(
    () => [
      urlManager.searchParams.get("priceMin"),
      urlManager.searchParams.get("priceMax"),
    ],
    [url]
  );

  const sidebar = useRef(null);
  const minusSubCollection = useRef(null);
  const contentSubCollection = useRef(null);
  const facetBlock = useRef(null);
  const [isViewMore, setViewMore] = useState(false);
  const [clearForm, setClearForm] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const addAOS = () => {
    if (sidebar && sidebar.current) {
      if (window.innerWidth >= 1024) {
        sidebar.current.setAttribute("data-aos", "fade-up");
      } else {
        if (sidebar.current.hasAttribute("data-aos")) {
          sidebar.current.removeAttribute("data-aos");
        }
      }
      AOS.refreshHard();
    }
  };

  addAOS();

  window.addEventListener("resize", () => {
    addAOS();
  });

  const pointViewMore = 10;

  const viewMore = (e) => {
    e.preventDefault();
    if (facetBlock.current.classList.contains("view-less")) {
      setViewMore(false);
      facetBlock.current.classList.remove("view-less");
      contentSubCollection.current.style.height = `${
        (pointViewMore + 1) * 24
      }px`;
    } else {
      setViewMore(true);
      facetBlock.current.classList.add("view-less");
      setTimeout(() => {
        contentSubCollection.current.style.height =
          contentSubCollection.current.scrollHeight + "px";
      }, 200);
    }
  };

  useEffect(() => {
    const userInteractionEvents = ["scroll", "mousedown", "mousemove", "click", "keydown", "touchstart"]
    userInteractionEvents.forEach( event => {
      window.addEventListener(event, () => {
        if (!showSidebar) {
          setShowSidebar(true)
        }
      }, { passive: true })
    }) 

    if (document.body.getBoundingClientRect() && (document.body.getBoundingClientRect().y !== 0) && !showSidebar) {
      setShowSidebar(true)
    }
  }, [products])

  useEffect(() => {
    if (!contentSubCollection.current) {
      return;
    }
    contentSubCollection.current.style.height =
      contentSubCollection.current.scrollHeight + "px";
  }, []);

  const toggleSubCollection = () => {
    if (facetBlock.current.classList.contains("close")) {
      facetBlock.current.classList.remove("close");
    } else {
      facetBlock.current.classList.add("close");
    }

    if (minusSubCollection.current.classList.contains("hide")) {
      minusSubCollection.current.classList.remove("hide");
      contentSubCollection.current.style.height =
        contentSubCollection.current.scrollHeight + "px";
    } else {
      minusSubCollection.current.classList.add("hide");
      contentSubCollection.current.style.height = "0";
    }
  };

  const closeSidebar = () => {
    document.querySelector(".js-plp-sidebar").classList.remove("open");
    document.body.classList.remove("overflow-hidden");
  };

  const resetFilter = useCallback(
    (e) => {
      e.preventDefault();

      setClearForm(!clearForm);

      urlManager.searchParams.delete("refinerFilters");
      urlManager.searchParams.delete("range");
      urlManager.searchParams.delete("priceMin");
      urlManager.searchParams.delete("priceMax");

      return setUrl(urlManager.href);
    },
    [url, facets]
  );

  const loadingArray = new Array(5).fill(0);
  const loadingFacetArray = new Array(5).fill(0);

  return (
    <div
      className="fixed flex lg:block justify-end right-0 top-0 h-screen w-full translate-x-[100%] [&.open]:translate-x-0 z-30 lg:relative lg:translate-x-0 lg:w-auto md:h-auto js-plp-sidebar"
      ref={sidebar}
    >
      {pickedFacets && pickedFacets.length > 0 ? (
        <div class="pb-[20px] hidden lg:flex">
          <h3 class="h3 hidden">Filter</h3>
          {(refinerFilters && refinerFilters.filter(Boolean).length) ||
          (range && range.filter(Boolean).length) ||
          (price && price.filter(Boolean).length) ? (
            <button
              type="button"
              class="button__clear button-text border-b-[1.5px] border-solid border-black h-5 block"
              onClick={resetFilter}
            >
              Clear All
            </button>
          ) : (
            ""
          )}
        </div>
      ) : (
        <></>
      )}
      <div
        className="fixed w-full h-full inset-0 bg-black-20 lg:hidden"
        onClick={closeSidebar}
      ></div>
      <button
        className="absolute top-2 right-[293px] sm:right-[302px] lg:left-[320px] lg:top-3 bg-white rounded-full w-[18px] h-[18px] lg:w-6 lg:h-6 overflow-hidden flex justify-center items-center lg:hidden"
        type="button"
        onClick={closeSidebar}
        aria-label="Close"
      >
        <div className="icon inline-flex justify-center items-center text-black bg-white w-[8px] h-[8px] lg:w-3 lg:h-3 z-10">
          <svg
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.887695 0.868164L12.2861 12.2661"
              stroke="currentColor"
            ></path>
            <path
              d="M12.2861 0.868164L0.887695 12.2661"
              stroke="currentColor"
            ></path>
          </svg>
        </div>
      </button>
      <div className="px-4 py-5 bg-white w-[267px] z-20 lg:w-auto lg:p-0 xl:max-w-[235px] h-screen overflow-auto lg:h-auto lg:overflow-visible">
        {products && showSidebar ? (
          <Fragment>
            {subCollections ? (
              <div
                className="relative pb-4 mb-4 lg:pb-[25px] lg:mb-[25px] border-b"
                ref={facetBlock}
              >
                <h2
                  className="flex justify-between h4 mb-4 cursor-pointer"
                  onClick={toggleSubCollection}
                >
                  <span>Categories</span>{" "}
                  <span
                    ref={minusSubCollection}
                    className="after:content-['–'] after:block [&.hide]:after:content-['+']"
                  ></span>
                </h2>
                <ul
                  className="flex flex-col [.close>&]:z-[-1] [.close>&]:opacity-0 [.close>&]:invisible transition-height duration-300"
                  ref={contentSubCollection}
                >
                  {subCollections.map((sub, index) => (
                    <Fragment>
                      <li
                        className={
                          index >= pointViewMore && !isViewMore ? "hidden" : ""
                        }
                      >
                        <a
                          href={sub.link}
                          className="category-link p1 link relative after:content-[''] after:absolute after:left-0 after:bottom-[-2px] after:w-0 after:h-[1px] after:bg-black after:transition-[width] after:duration-300 after:ease-linear hover:after:w-full"
                        >
                          {sub.title}
                        </a>
                      </li>
                    </Fragment>
                  ))}
                  <li
                    className={
                      subCollections.length <= pointViewMore ? "hidden" : ""
                    }
                  >
                    <a
                      href="#"
                      onClick={viewMore}
                      className="p1 link-underline mb-1 font-bold align-left"
                    >
                      {isViewMore ? `View Less -` : `View More +`}
                    </a>
                  </li>
                </ul>
              </div>
            ) : (
              ""
            )}

            {pickedFacets ? (
              <div class="grid gap-2">
                <div className="pb-[100px] lg:pb-0">
                  {pickedFacets.map((facet) => (
                    <Facet
                      facet={facet}
                      clearForm={clearForm}
                      key={facet.filter.name}
                    />
                  ))}
                </div>
                <div className="fixed flex flex-col items-center w-[267px] bottom-0 right-0 bg-white p-4 border-t lg:hidden">
                  <button class="btn-primary w-full" onClick={closeSidebar}>
                    Apply Filters
                  </button>
                  <a
                    href="#"
                    className="mt-2 p3 link-underline"
                    onClick={resetFilter}
                  >
                    Reset Filters
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
          </Fragment>
        ) : (
          <Fragment>
            <div class="grid gap-2 w-[267px]">
              {loadingArray.map((_) => (
                <div className="py-4 border-b md:py-5">
                  <h2 class="h-6 block-loading"></h2>
                  <ul class="mt-2 grid gap-1.5 overflow-hidden">
                    {loadingFacetArray.map((_, index) => (
                      <li
                        key={index}
                        class="block-loading h-4 w-[90%] [&:nth-child(2n)]:w-[70%]"
                      ></li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
}
